import React from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

export default class SelectFieldWrapper extends React.Component {

  state = {
    value : '',
    errorText : null
  };

  componentWillReceiveProps = newProps =>{
    this.setState({
      value: newProps.value,
      errorText: newProps.errorText
    })
  };

  componentWillMount(){
    this.setState({
      value: this.props.value
    })
  }

  handleChange = (event, index, value) => {
    this.props.onChange({target: {name: this.props.name, value: value || index}});
  };

  shouldComponentUpdate = nextProps => {
    const { elements } = this.props;
    return this.state.value !== nextProps.value || this.state.errorText !== nextProps.errorText || elements.length !== nextProps.elements.length
  };

  render(){
    return(
      <SelectField
        errorText={this.state.errorText}
        selectedMenuItemStyle={{color: 'white', backgroundColor: '#467093'}}
        underlineFocusStyle={{backgroundColor: '#467093'}}
        value={this.state.value}
        onChange={this.handleChange}
        fullWidth={this.props.fullWidth}
        multiple={this.props.multiple}
        floatingLabelText={this.props.floatingLabelText || ''}
        hintText={this.props.placeholder}>
        { this.props.elements.map( (el, i) => <MenuItem value={el.value}
                                                        key={i}
                                                        primaryText={el.title}/>)
        }
      </SelectField>
    )
  }
}







// WEBPACK FOOTER //
// ./src/modules/blocks/SelectFieldWrapper.js